import sidebarAttributes from "./sidebar.json";

export default {
  ...sidebarAttributes,
};
